import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { getRequest } from "../../../src/utils/API/api.ts";
import styles from "./Landing.module.css";
import axios from "axios";
import TextInputP from "../../common/inputElements/TextInputP";
import { useMatch, useNavigate } from "react-router-dom";
import { FormControl } from "../eventLayout/settings2/regForm/FormControl";
import CountryCityRegForm from "./CountryCityRegForm.jsx";
import countryCodes from "../../utils/CountryCodes.json";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../redux/actions/toastActions.js";
import { getSingleEvent } from "../../redux/actions/eventActions";

const LandingRegForm = ({
  // singleEvent,
  setIsRegistered,
  setRegisteredUserEmail,
}) => {
  const [regForm, setRegForm] = useState([]);
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const eventsId = useMatch("/event/:eventId");
  const [triggerInfo, setTriggerInfo] = useState(false);
  const navigate = useNavigate();
  const formMethods = useForm();
  const [countryResult, setCountryResult] = useState([]);
  const [cityResult, setCityResult] = useState([]);
  const [stateResult, setStateResult] = useState([]);
  const [triggerCode, setTriggerCode] = useState(false);
  const [countryCode, setCountryCode] = useState("+91");
  const [allCountryCode, setAllCountryCode] = useState(countryCodes);
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = formMethods;
  const singleEvent = useSelector((state) => state.eventData);

  // useEffect(()=>{

  // },[])

  useEffect(() => {
    const getAdditionalForm = async () => {
      const response = await getRequest(
        `/event/${eventsId.params.eventId}/additionalForm`
      );
      setRegForm(response.data[0]?.form);
    };
    if (eventsId.params.eventId) {
      getAdditionalForm();
      dispatch(getSingleEvent({ eventId: eventsId.params.eventId }));
    }
  }, [eventsId]);

  async function onFormSubmit(data, error) {
    let check;
    if (singleEvent.isPaid) {
      // console.log(data.email);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/user/find`,
          {
            email: data.email.toLowerCase(),
          }
        );
        check = response.data.savedUserConfig;
        const attended = singleEvent.attendees.find(
          (element) => element === check._id
        );

        if (attended) {
          // console.log(a)
          dispatch(
            showToast({
              message: "User Already Registered",
              category: "success",
            })
          );
          return;
        } else {
          const organizer = singleEvent.organizer.find(
            (ele) => ele._id === check._id
          );
          if (organizer) {
            dispatch(
              showToast({
                message: "User is a organizer! Cant register",
                category: "success",
              })
            );
            return;
          }
        }
      } catch (error) {}
    }

    const matchingCountry = countryCodes.find(
      (country) => country.dial_code === countryCode
    );
    const regex = /^[\d]{10}$/;
    if (!matchingCountry) {
      dispatch(
        showToast({
          message: "Invalid Country Code.",
          category: "danger",
        })
      );
      setIsSubmitting(false);
      return;
    }

    if (!regex.test(data.mobile)) {
      dispatch(
        showToast({
          message: "Invalid Mobile Number",
          category: "danger",
        })
      );
      setIsSubmitting(false);
      return;
    }

    let additionalData = {};
    if (Object.keys(data).length > 6) {
      for (const prop in data) {
        if (
          prop !== "firstName" &&
          prop !== "lastName" &&
          prop !== "mobile" &&
          prop !== "email" &&
          prop !== "organization" &&
          prop !== "jobTitle" &&
          prop !== "country" &&
          prop !== "state" &&
          prop !== "city" &&
          prop !== "gender"
        ) {
          additionalData[prop] = data[prop];
        }
      }
    }
    setIsSubmitting(true);
    if (singleEvent?.isPaid) {
      navigate(`/event/${singleEvent?._id}/checkout`);
      localStorage.setItem(
        "tempUserPayDetails",
        JSON.stringify({
          firstName: data.firstName.trim(),
          lastName: data.lastName.trim(),
          mobile: data.mobile,
          countryCode: countryCode,
          email: data.email.toLowerCase().trim(),
          eventId: eventsId.params.eventId,
          jobTitle: data.jobTitle,
          organization: data.organization,
          country: data.country,
          state: data.state,
          city: data.city,
          gender: data.gender,
          additionalData: additionalData,
        })
      );
      return;
    }

    const url = singleEvent?.isRegistrationApproval
      ? "requestEventRegistration"
      : "eventregister";
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/attendee/${url}`, {
        firstName: data.firstName,
        lastName: data.lastName,
        mobile: data.mobile,
        countryCode: countryCode,
        email: data.email.toLowerCase(),
        eventId: eventsId.params.eventId,
        jobTitle: data.jobTitle,
        organization: data.organization,
        country: data.country,
        state: data.state,
        city: data.city,
        gender: data.gender,
        additionalData: additionalData,
      })
      .then(function (response) {
        setRegisteredUserEmail(data.email.toLowerCase());
        reset();
        setIsSubmitting(false);
        setIsRegistered(true);
      })
      .catch(function (error) {
        let message = error.response.data.message;
        reset();
        setIsSubmitting(false);
        if (message === "You have already registered for this event") {
          dispatch(
            showToast({
              message: "You have already registered for this event",
              category: "danger",
            })
          );
        } else if (error.response.status === 409) {
          dispatch(
            showToast({
              message: `Your registration for this event is ${message}.`,
              category: "danger",
            })
          );
        } else {
          dispatch(
            showToast({
              message: `Sorry, something went wrong`,
              category: "danger",
            })
          );
        }

        setIsSubmitting(false);
      });
  }

  let resizeWindow = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, []);

  useEffect(() => {
    if (countryCode) {
      const matchingCountries = countryCodes.filter(
        (country) =>
          country.dial_code
            .toLowerCase()
            .startsWith(countryCode.toLowerCase()) ||
          country.name.toLowerCase().startsWith(countryCode.toLowerCase()) ||
          country.code.toLowerCase().startsWith(countryCode.toLowerCase())
      );

      const nonMatchingCountries = countryCodes.filter(
        (country) =>
          !(
            country.dial_code
              .toLowerCase()
              .startsWith(countryCode.toLowerCase()) ||
            country.name.toLowerCase().startsWith(countryCode.toLowerCase()) ||
            country.code.toLowerCase().startsWith(countryCode.toLowerCase())
          )
      );

      setAllCountryCode([...matchingCountries, ...nonMatchingCountries]);
    }
  }, [countryCode]);

  return (
    <div className="w-[100%] mymd:w-full">
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className={styles.reg_form_box}
      >
        <div className="flex flex-col gap-2">
          {singleEvent?.isRegistrationApproval && (
            <div className="flex rounded-xl bg-[#F5F5F5] p-2.5">
              <div className="border rounded-lg p-2 shadow h-[43px] w-[43px]">
                <img
                  src="/svgs/person_add.svg"
                  alt="person"
                  className="w-[25px]"
                />
              </div>
              <div className="ml-3">
                <p className="font-[500]">Approval Required</p>
                <p className="font-[400] text-[14px]">
                  Registration will be granted upon the host's approval.
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="mymd:w-[500px] flex items-center mb-5 mt-3">
          <input
            type="checkbox"
            id="radiobtn"
            className="mr-2 border-[#cacaca] border-2 bg-white checked:bg-primary checked:border-[#d5d8dd] cursor-pointer focus:ring-0"
            checked={false}
            onChange={() =>
              navigate(
                `/event/${eventsId.params.eventId}?tab=${"registerlinkedin"}`
              )
            }
          />
          <label htmlFor="radiobtn" className=" cursor-pointer ">
            <span className="flex text-[14px] font-[600] items-center">
              Share this on&nbsp;
              <img src="/svgs/linkedinblue.svg" alt="linkedin" /> &nbsp;Linkedin
            </span>
          </label>
          <div className=" relative">
            <img
              src="/svgs/info.svg"
              className="h-[20px] ml-1 cursor-pointer"
              onMouseEnter={() => setTriggerInfo(true)}
              onMouseLeave={() => setTriggerInfo(false)}
              alt="info"
            />
            {triggerInfo && (
              <p className="text-[12px] absolute z-20 bg-gray-700 p-2 rounded-md text-white w-[200px] left-[20px]">
                Tick here to share you are attending this event on your
                linkedin. By opting in you understand that your profile details
                will be shared with us for marketing purpose.
              </p>
            )}
          </div>
        </div>

        <div className="mymd:w-full mymd:flex pt-[15px] w-[100%] justify-between gap-1">
          <div className="flex gap-2 relative">
            <label
              htmlFor="firstName"
              className="absolute left-2 -top-5 mb-1 text-sm peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-900 peer-placeholder-shown:text-opacity-40 peer-placeholder-shown:top-[10px] peer-placeholder-shown:left-[13px] transition-all peer-focus:-top-5 peer-focus:text-gray-900 peer-focus:text-opacity-40 peer-focus:text-[12.5px] text-gray-900 text-opacity-40 dark:text-gray-300 font-[600]"
            >
              First Name&nbsp;<span className="text-red-500">*</span>
            </label>
            <div>
              <select
                id="title"
                name="title"
                {...register("gender")}
                required
                className={`
              w-[80px]
              peer bg-[#F4F6F9] border-0 text-gray-900 text-[13px]  placeholder-transparent focus:ring-transparent py-0 bg-[right] 1.5rem font-medium focus:border-primary focus:border-[2px] rounded-lg h-[40px]
             `}
              >
                <option value="Male">Mr.</option>
                <option value="Female">Ms.</option>
                <option value="Female">Mrs.</option>
                <option value="Dr.">Dr.</option>
                <option value="Prof.">Prof.</option>
              </select>
            </div>

            <div className="w-[100%]">
              <input
                type="text"
                id="firstName"
                className="relative mb-[32px] w-[100%] 
                peer bg-[#F4F6F9] border-0 border-gray-200 text-gray-900 text-[13px] rounded-lg h-[40px] placeholder-transparent focus:ring-transparent focus:border-primary focus:border-[2px] dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-[500]  dark:focus:ring-blue-500 dark:focus:border-blue-500 flex py-0 items-center"
                // placeholder={label}
                {...register("firstName")}
              />
            </div>
          </div>
          <TextInputP
            register={register}
            type="text"
            id={"lastName"}
            label="Last Name"
            required
            // minLength={0}
            width={windowWidth > 900 ? "220px" : ""}
          />
        </div>

        <TextInputP
          register={register}
          type="email"
          id={"email"}
          label="Email Address"
          required
          errors={errors}
          pattern={
            /^([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/i
          }
          width={"100%"}
          mb="[32px]"
        />

        <div className="mymd:w-full flex w-[100%] justify-between relative gap-2 mb-[32px]">
          <label
            htmlFor="mobile"
            className="absolute left-2 -top-5 mb-1 text-sm peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-900 peer-placeholder-shown:text-opacity-40 peer-placeholder-shown:top-[10px] peer-placeholder-shown:left-[13px] transition-all peer-focus:-top-5 peer-focus:text-gray-900 peer-focus:text-opacity-40 peer-focus:text-[12.5px] font-semibold text-gray-900 text-opacity-40 dark:text-gray-300"
          >
            <>
              Phone Number&nbsp;<span className="text-red-500">*</span>
            </>
          </label>
          <div
            className="relative pr-2.5
             peer bg-[#F4F6F9] border-0 border-gray-200 text-gray-900 text-[12px] rounded-lg h-[40px] placeholder-transparent focus:ring-transparent focus:border-primary focus:border-[2px] dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500 flex py-0 items-center"
          >
            <div className="flex items-center relative">
              <label htmlFor="code" className="hidden">
                Code
              </label>
              <input
                type="text"
                id="code"
                required
                value={countryCode}
                onFocus={() => setTriggerCode(true)}
                onBlur={() => setTriggerCode(false)}
                onChange={(event) => setCountryCode(event.target.value)}
                // {...register("code")}
                className={`w-[55px]
                    peer bg-[#F4F6F9] border-0 border-gray-300 text-gray-900 text-[13px] rounded-lg h-[30px] placeholder-transparent focus:ring-transparent block pl-1.5 focus:border-primary focus:border-[2px]  `}
                autoComplete="off"
              />
              <img
                src="/svgs/arrow.svg"
                alt=""
                onClick={() => setTriggerCode(!triggerCode)}
                className="transform rotate-180 h-[16px] cursor-pointer ml-2 mr-3"
              />
            </div>

            {triggerCode && (
              <div className="border max-h-[130px] absolute w-[83px] z-20 bg-white overflow-y-scroll rounded-lg border-primary top-[40px]">
                {allCountryCode?.map((codes) => (
                  <span
                    // key={result}
                    className="w-[100%] flex h-[40px] items-center pl-2 text-[13px] font-[500] cursor-pointer hover:bg-gray-200 "
                    onMouseDown={(event) => {
                      setCountryCode(codes.dial_code);
                      setTriggerCode(false);
                      event.stopPropagation();
                    }}
                  >
                    {codes.code} {codes.dial_code}
                  </span>
                ))}
              </div>
            )}
          </div>

          <div
            className="w-[100%] bg-[#F4F6F9] rounded-lg"
            onClick={() => setTriggerCode(false)}
          >
            <input
              type="tel"
              id="mobile"
              maxLength={10}
              required
              className={`w-[100%]
                bg-[#F4F6F9] border-0 border-gray-200 text-gray-900 text-[13px] h-[40px] placeholder-transparent focus:ring-transparent p-0 appearance-none bg-transparent focus:outline-none focus:ring-0 pl-2 focus:border-primary focus:border-[2px] block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500 rounded-lg
           `}
              {...register("mobile")}
              style={{ backgroundColor: "transparent" }}
            />
          </div>
        </div>

        <TextInputP
          register={register}
          type="text"
          id={"organization"}
          required
          label="Company Name"
          width={"100%"}
          mb="[32px]"
        />
        <TextInputP
          register={register}
          type="text"
          id={"jobTitle"}
          required
          label="Designation"
          width={"100%"}
          mb="[32px]"
        />

        <FormProvider {...formMethods}>
          {regForm &&
            regForm.length > 0 &&
            regForm.map((form, key) => (
              <div key={key}>
                <CountryCityRegForm
                  form={form}
                  setCountryResult={setCountryResult}
                  countryResult={countryResult}
                  cityResult={cityResult}
                  setCityResult={setCityResult}
                  setStateResult={setStateResult}
                  stateResult={stateResult}
                />
              </div>
            ))}
        </FormProvider>

        <FormProvider {...formMethods}>
          {regForm &&
            regForm.length > 0 &&
            regForm.map((ele, key) => (
              <div key={key}>
                <FormControl {...ele} showIcons={false} width={"100%"} />
              </div>
            ))}
        </FormProvider>

        <div className="mymd:w-[100%] mymd:flex flex-col">
          <button
            type="submit"
            disabled={isSubmitting}
            className={styles.submit_btn}
          >
            {isSubmitting ? "Loading..." : "Register"}
          </button>
          <div
            className="text-center text-[14px] mt-[15px] cursor-pointer"
            onClick={() =>
              window.open(`${window.location.origin}/login`, "_blank")
            }
          >
            <span>
              Already Registered?{" "}
              <span className="text-primary font-[500]">Login</span>
            </span>
          </div>
        </div>
      </form>
    </div>
  );
};

export default LandingRegForm;
